module.exports = __webpack_public_path__ + "static/media/bg.5b3979a9.png";